/**
 * @generated SignedSource<<84d8bf105ebcfe50227d871d6d105095>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ThemeKind = "custom" | "dark" | "light" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CustomThemeProviderActiveOrganizationFragment$data = {
  readonly theme: {
    readonly backgroundColor: string | null;
    readonly cardBackgroundColor: string | null;
    readonly kind: ThemeKind;
    readonly navBackgroundColor: string | null;
    readonly primaryColor: string | null;
    readonly primaryContrastColor: string | null;
  } | null;
  readonly " $fragmentType": "CustomThemeProviderActiveOrganizationFragment";
};
export type CustomThemeProviderActiveOrganizationFragment$key = {
  readonly " $data"?: CustomThemeProviderActiveOrganizationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomThemeProviderActiveOrganizationFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomThemeProviderActiveOrganizationFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Theme",
      "kind": "LinkedField",
      "name": "theme",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryContrastColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cardBackgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "navBackgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "kind",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "187b4fc2d54097ce37656b0ffc96cc35";

export default node;
